import { Button, EButtonType } from '@/components/Button';
import { DisplayButtons } from '@/components/DisplayButtons';
import {
    EDisplays,
    EJourneys,
    EModals,
    setDisplay,
    setModal,
} from '@/context/display';
import { useAppDispatch } from '@/context/storeHooks';
import { useCopy, useFieldCopy } from '@/copy';
import { EParameters, getParameters } from '@/utils/setParametersFromParams';

interface IIndicativelyApprovedButtonsProps {
    baseId?: string;
}

export function IndicativelyApprovedButtons({
    baseId,
}: IIndicativelyApprovedButtonsProps): JSX.Element {
    const dispatch = useAppDispatch();
    const params = getParameters();
    const { financeOptionCard } = useCopy();
    const fields = useFieldCopy();

    // ***** Event Handlers *****
    function handleBackClick(): void {
        const paramJourney = params.get(EParameters.INITIAL_JOURNEY);

        if (paramJourney?.toLocaleUpperCase() === EJourneys.TEST_DRIVE) {
            dispatch(setDisplay(EDisplays.INCOME));
            return;
        }
        dispatch(setDisplay(EDisplays.OCR_SUMMARY));
    }

    function handleNextClick(): void {
        dispatch(setModal(EModals.POSTAPPROVED_PERMISSION_MODAL));
    }

    /**
     * Each finance option carries its own CTA, so there is no Next to pair a
     * back button with — but the customer still needs a way back to correct
     * their details.
     */
    if (financeOptionCard) {
        return (
            <div className='_flex pt-6 pb-2'>
                <Button
                    id={`${baseId}-button-back`}
                    onClick={handleBackClick}
                    type={EButtonType.SECONDARY_OUTLINE}
                >
                    <p className='text-sm'>{fields.backButton}</p>
                </Button>
            </div>
        );
    }

    return (
        <DisplayButtons
            idLeftButton={`${baseId}-button-back`}
            idRightButton={`${baseId}-button-next`}
            rightClick={handleNextClick}
            leftClick={handleBackClick}
        />
    );
}
